import { cn } from '@/lib/cn';
import { flagByKey, flagGradient } from '@shared/flags';

interface Props {
  /** the category's stored flag key; null/unknown renders nothing */
  flag: string | null;
  /** badge diameter in px — scaled to the circle it sits on */
  size?: number;
  /** knockout border in px, so the badge doesn't melt into the circle's edge */
  ring?: number;
  /** border colour of whatever the circle sits ON, e.g. `border-surface` */
  className?: string;
}

// The flag disc in the bottom-right corner of an origin category's icon circle.
// Needs a `relative` parent. Pure decoration — the category label already names
// the country, so it stays out of the accessibility tree.
export default function FlagBadge({ flag, size = 20, ring = 2, className }: Props) {
  const country = flagByKey(flag);
  if (!country) return null;
  return (
    <span
      aria-hidden
      className={cn('absolute -bottom-px -right-px rounded-full border-bg', className)}
      style={{
        width: size,
        height: size,
        borderWidth: ring,
        backgroundImage: flagGradient(country),
      }}
    />
  );
}
